module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","apply":"Apply","from":"From","to":"To"},"ar":{"cancel":"اغلاق","apply":"اختيار","from":"من","to":"الى"}}')
  delete Component.options._Ctor
}
